// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"a2d61384","455":"d7dd1680","788":"a16d80b2","882":"af9ef341"}[chunkId] + ".chunk.js";
};